import * as React from "react"
import styled from 'styled-components';
import { Seo } from "../../components/seo"
import Layout from "../../components/layout"
import CompareHero from "../../components/compare-email-verifier/pages-component/hero";
import CompareOthers from "../../components/compare-email-verifier/pages-component/compare-cards";
import CovsOthers from "../../components/compare-email-verifier/pages-component/co-vs-others-table";
import CreateAccount from "../../components/compare-email-verifier/pages-component/create-account";

const StyledHome = styled("div")`

`

const ComparePage = () => {
  return (
    <Layout>
      <StyledHome>
        <section className="py-5 hero-section">
          <CompareHero />
        </section>
        <section className="compare-others-section">
          <CompareOthers />
        </section>
        <section className="co-vs-others-section">
          <CovsOthers />
        </section>
        <section className="py-5 CreateAccount-section">
          <CreateAccount />
        </section>
      </StyledHome>
    </Layout>
  )
}

export default ComparePage

export const Head = () => (
  <Seo
    title="Clearout Email Verifier Alternatives & Competitors Compared"
    description="Compare the top email verification tools and services, and see why Clearout's Email Verifier stands out for its high accuracy and unique features."
    keywords="list of email verification tools compared, email verification tools, clearout vs zerobounce, clearout vs neverbounce, clearout vs kickbox, clearout vs debounce, clearout vs briteverify, clearout vs bouncer"
  />

)